import { AfterViewInit, Directive } from '@angular/core'
import { activateTooltipsForComponent } from '../utils/utils'

@Directive({
    selector: '[appTooltipComponent]',
    standalone: true,
})
export class TooltipComponentDirective implements AfterViewInit {
    ngAfterViewInit(): void {
        activateTooltipsForComponent()
    }
}
